import { api } from '@/services';

export default {
  async fetchSolicitacoesNumerario({ dispatch, commit }, payload) {
    try {
      const { codigoProcesso, codigoFilial } = payload;

      return await api.get(`/numerario/processo/${codigoProcesso}/filial/${codigoFilial}`)
        .then((response) => {
          commit('SET_NUMERARIO_SOLICITACAO', response.data.registros);
        });
    } catch (err) {
      return dispatch('setGlobalError', 'Não foi possível recuperar as solicitações!', {
        root: true,
      });
    }
  },
  async fetchItensNumerario({ dispatch, commit }, payload) {
    try {
      const { PRI_COD, FIL_COD } = payload;

      return await api.get(`/numerario/${PRI_COD}/filial/${FIL_COD}`)
        .then((response) => {
          commit('SET_NUMERARIO_ITENS', response.data.registros);
        });
    } catch (err) {
      return dispatch('setGlobalError', 'Não foi possível recuperar os itens!', {
        root: true,
      });
    }
  },
};
